import Input from "../../component/common/Input";
import Button from "../../component/common/Button";
import { ReactComponent as EmailIcon } from "../../assets/@.svg";
import { ReactComponent as LockIcon } from "../../assets/lock.svg";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { setToken } from "../../utils/browserSetting";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { toast } from "react-toastify";
import httpServices from "../../services/httpServices";
import CryptoJS from 'crypto-js';


const loginSchema = yup.object().shape({
  emailId: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  password: yup.string().required("Password is required"),
});

const Login = () => {
  const navigate = useNavigate();
  const { user, setUser, setIsSimpleUser, isSimpleUser } = useUser();

  useEffect(() => {
    if (user && isSimpleUser) {
      navigate("/events");
    } else if (user) {
      navigate("/");
    }
  }, [user, isSimpleUser]);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const onSubmit = async (data) => {
    try {

      const hashedPassword = CryptoJS.MD5(data.password).toString(CryptoJS.enc.Base64);

      const { response, error } = await httpServices.post("/users/login", {
        password: hashedPassword,
        emailId: data?.emailId,
      });

      if (error) {
        throw error;
      }
      if (response?.status === 200) {
        toast.success("Login successful");
        setUser(response?.data);
        setIsSimpleUser(response?.data?.userType == 0);
        setToken(response.data.accessToken);
        // navigate("/");
      }
    } catch (error) {
      console.log("Error during login:", error);
      toast.error(error.response.data.message);
    }
  };

  const onError = (errors) => {
    console.log(errors);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-white p-[10px] sm:p-10">
      <div className="card w-[491px]">
        <h1 className="heading">Welcome Back 👋</h1>
        <p className="paragraph">
          Sign in to your account to continue. If you don't have an account, you
          can create one.
        </p>
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <div className="space-y-6">
            <Input
              Icon={EmailIcon}
              label={"Email"}
              {...register("emailId")}
              placeholder={"Email address"}
              isForgotPassword={true}
            />
            {errors.emailId && (
              <p className="text-red-500 text-sm">{errors.emailId.message}</p> // Show email validation error
            )}

            <Input
              Icon={LockIcon}
              type={"password"}
              {...register("password")}
              label={"Password"}
              placeholder={"Password "}
            />
            {errors.password && (
              <p className="text-red-500 text-sm">{errors.password.message}</p> // Show password validation error
            )}
          </div>

          <div className="inline-flex space-x-2 mt-[44px] items-center">
            <label
              className="relative flex items-center  rounded-full cursor-pointer"
              htmlFor="link"
            >
              <input
                type="checkbox"
                className="relative h-4 w-4 cursor-pointer  outline-300-gray rounded-md block"
                id="link"
              />
            </label>
            <label
              className="mt-px font-light text-gray-700 cursor-pointer select-none"
              htmlFor="link"
            >
              <p className="flex text-[13px] font-medium leading-relaxed text-900-gray">
                Remember Me
              </p>
            </label>
          </div>

          <Button
            content="Sign In"
            classes="mt-[19px] w-full hover:bg-[#3872A5] duration-300 justify-center"
            type="submit"
          />
        </form>
      </div>
    </div>
  );
};

export default Login;
